import React from "react";
import { createPortal } from "react-dom";
// styles
import styles from "./ConfirmModal.module.css";

const modalRoot = document.getElementById("modal");

export default function ConfirmModal({
  message,
  onConfirm,
  onCancel = () => {},
}) {
  return createPortal(
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h3> {"Confirm"} </h3>
        <div className={styles.message}> {message} </div>
        <div className={styles.buttonContainer}>
          <button className={styles.confirmButton} onClick={() => onConfirm()}>
            {" "}
            {"Save"}{" "}
          </button>
          <button className={styles.cancelButton} onClick={() => onCancel()}>
            {" "}
            {"Cancel"}{" "}
          </button>
        </div>
      </div>
    </div>,
    modalRoot
  );
}
